var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_smart_park"},[_vm._v("\n\t预留核销页\n")])}
var staticRenderFns = []

export { render, staticRenderFns }